export const FORMATO_DATA = 'DD/MM/YYYY'

export const MASCARA_DATA = '##/##/#### - ##/##/####'

export const datePickerLocale = {
  fromLabel: 'De',
  toLabel: 'a',
  applyLabel: 'Aplicar',
  cancelLabel: 'Limpar',
  daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
}

export function buildRanges() {
  return {
    'Hoje': [moment(), moment()],
    'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Últimos 7 dias': [moment().subtract(6, 'days'), moment()],
    'Últimos 30 dias': [moment().subtract(29, 'days'), moment()],
    'Esse mês': [moment().startOf('month'), moment().endOf('month')],
    'Último mês': [
      moment().subtract(1, 'month').startOf('month'),
      moment().subtract(1, 'month').endOf('month'),
    ],
    'Este ano': [moment().startOf('year'), moment()],
  }
}
